import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: "15px",
  },
  sectionMargin: {
    margin: "28px 0 30px",
  },
  cardMargin: {
    margin: "0 -10px 30px -10px",
  },
  boostMargin: {
    margin: "0 0 30px 0",
  },
  cardText: {
    margin: "0 0 20px 0px",
  },
  textMargin: {
    marginBottom: "20px",
  },
  dashtypo: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    paddingBottom: "15px",
  },
  head: {
    border: `1px solid  ${theme.palette.customColor.LINE}`,
    borderRadius: theme.borderRadius.value,
    paddingBottom: "15px",
    "& .header .link": {
      color: theme.palette.customColor.SECONDARY,
      textDecoration: "none",
      whiteSpace: "nowrap",
      marginLeft: "10px",
      "&:hover": {
        color: theme.palette.customColor.TERTIARY,
      },
    },
  },
  headerItem: {
    "&.header": {
      borderBottom: `1px solid  ${theme.palette.customColor.LINE}`,
      padding: "15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& .link": {
        color: theme.palette.customColor.SECONDARY,
        textDecoration: "none",
        whiteSpace: "nowrap",
        marginLeft: "10px",
        fontSize: "12px",
        "&:hover": {
          color: theme.palette.customColor.TERTIARY,
          textDecoration: "underline",
        },
      },
    },
  },
  description: {
    color: "#2D2D39",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 4,
    wordBreak: "break-word",
  },
}));
